/** @format */

import React, { ReactElement } from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { ReactComponent as DownCurvedArrow } from '../../assets/themes/OPL/img/icons/DownCurvedArrow.svg';

function DeactivateFeatureButton({ ...props }): ReactElement {
    const { classes, callback, callbackParam, color, text, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            className={classes}
            classes={classes}
            icon={DownCurvedArrow}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
        />
    );
}

DeactivateFeatureButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
};

export default DeactivateFeatureButton;
